module.exports = __webpack_public_path__ + "assets/logo-white.4e10506f.svg";